import React, { useEffect, useRef } from 'react';

const Skills = () => {
  const skillsRef = useRef(null);

  const programmingLanguages = [
    { name: 'JavaScript', level: 90 },
    { name: 'Java', level: 85 },
    { name: 'C++', level: 80 },
    { name: 'Python', level: 90 }
  ];

  const frameworks = [
    'React.js', 'Node.js', 'Express.js', 'HTML/CSS',
    'PostgreSQL', 'Oracle', 'AWS', 'Docker',
    'Git/GitHub', 'RAG', 'GenAI', 'PyContracts'
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const skillBars = entry.target.querySelectorAll('.skill-progress');
            skillBars.forEach((bar) => {
              const width = bar.style.width;
              bar.style.width = '0';
              setTimeout(() => {
                bar.style.width = width;
              }, 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    const currentRef = skillsRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section id="skills" className="skills" ref={skillsRef}>
      <div className="container">
        <h2 className="section-title">Skills & Technologies</h2>
        <div className="skills-content">
          <div className="skills-category">
            <h3 className="category-title">
              <i className="fas fa-code"></i> Programming Languages
            </h3>
            <div className="skills-list">
              {programmingLanguages.map((skill, index) => (
                <div key={index} className="skill-item">
                  <span className="skill-name">{skill.name}</span>
                  <div className="skill-bar">
                    <div className="skill-progress" style={{ width: `${skill.level}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="skills-category">
            <h3 className="category-title">
              <i className="fas fa-tools"></i> Frameworks & Tools
            </h3>
            <div className="skills-grid">
              {frameworks.map((framework, index) => (
                <div key={index} className="skill-badge">{framework}</div>
              ))}
            </div>
          </div>

          <div className="skills-category">
            <h3 className="category-title">
              <i className="fas fa-certificate"></i> Certifications
            </h3>
            <div className="certifications-list">
              <div className="certification-item">
                <div className="cert-icon">
                  <i className="fab fa-aws"></i>
                </div>
                <div className="cert-details">
                  <h4>AWS Certified Cloud Practitioner</h4>
                  <p>July 2024 – July 2027</p>
                  <span className="cert-badge">Valid</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;

